<script setup>
import multiselect from "vue-multiselect";
import {ref, watch} from "vue";
import {useStore} from "vue2-helpers/vuex";
import {getNumberWithNoun} from "../../helpers/string";

defineProps(['target', 'trackers', 'options']);
const emit = defineEmits(['addNew', 'add', 'remove']);

const store = useStore();

const popover = ref(null);
const addedTracker = ref(null);

watch(addedTracker, (value) => {
    if (value) {
        emit('add', value.id);

        addedTracker.value = null;
    }
});

function closePopover() {
    popover.value.$emit('close');
}

function createNewTracker() {
    emit('addNew');
    closePopover();
}
</script>

<template>
    <b-popover ref="popover" :target="target" placement="bottomright">
        <div class="popover__content popover__content--secondary" v-click-outside="closePopover">
            <header class="popover__content__header align-items-end flex-wrap flex-sm-nowrap">
                <h4 class="heading4">Add to tracker</h4>

                <a
                    v-if="store.state.user.permissions.includes('tracker-create')"
                    class="link"
                    @click="createNewTracker"
                >
                    Create New
                </a>
            </header>

            <div class="popover__content__body flex-column">
                <multiselect
                    class="multiselect multiselect-mid"
                    v-model="addedTracker"
                    :options="options"
                    select-label=""
                    deselect-label=""
                    label="name"
                    track-by="name"
                >
                    <template slot="option" slot-scope="props">
                        <span v-b-popover.hover.top="props.option.created_by + ': ' + props.option.created_at">{{props.option.name}}</span>
                    </template>
                </multiselect>

                <h4 class="heading4 mt-4" v-if="trackers?.length">
                    On {{getNumberWithNoun('tracker', trackers.length)}}
                </h4>

                <ul class="rows-list">
                    <li v-for="tracker in trackers" :key="tracker.id">
                        <h5 class="heading5 heading5--secondary"><a :href="'/trackers/' + tracker.id" target="_blank">{{ tracker.name }}</a></h5>
                        <a v-if="tracker.type !== 'public'" @click="emit('remove', tracker.id)" class="remove-action">Remove</a>
                    </li>
                </ul>
            </div>
        </div>
    </b-popover>
</template>

<style scoped>
    .popover {
        + .popover {
            padding: 5px 5px 5px 10px;
            width: 140px;
            font-size: 12px;
        }
    }
</style>
